import IconedText from './IconedText.vue'

type Themes = 'big' | 'link' | 'font-default' | 'center'

export interface Props {
  theme?: Themes | Array<Themes>
}

export default IconedText;